<template>
  <a class="badge" :href="hyperlink">
    <CustomIcon :name="image" class="badge-image" />
  </a>
</template>
<script>
import CustomIcon from "./CustomIcon.vue";
export default {
  props: {
    image: String,
    hyperlink: String,
  },
  components: { CustomIcon },
};
</script>
